module.exports = __webpack_public_path__ + "img/book-cover-2.55ad7f3c.png";